import { DEFAULT_CURRENCY_CODE, LOCALE_ID, NgModule } from '@angular/core';

import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ApiFakerModule } from '@core/api/faker/api-faker.module';
import { AppTranslateModule } from '@core/app-translate.module';
import { EnvConfig } from '@core/config';
import { CoreModule } from '@core/core.module';
import { getLocaleKey } from '@core/translate-utils';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { WaiMatPaginatorIntl } from '@shared/mat-paginator-intl.service';
import { ConnectionStatusComponent } from '@shared/connection-status/connection-status.component';

import { environment } from '../environments/environment';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DataroomModule } from '@shared/dataroom/dataroom.module';
// Temporarily removed for Angular 19 compatibility
// import { GoogleMapsModule } from '@angular/google-maps';
import { HttpClient, provideHttpClient, withJsonpSupport } from '@angular/common/http';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { AppTranslateLoader } from '@core/app-translate-loader';
import Lara from '@primeng/themes/lara';
import { providePrimeNG } from 'primeng/config';

export function HttpLoaderFactory(http: HttpClient, env: EnvConfig) {
  return new AppTranslateLoader(http, env);
}
@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    AppRoutingModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient, EnvConfig],
      },
    }),
    AppTranslateModule,
    BrowserModule,
    BrowserAnimationsModule,
    CoreModule,
    DataroomModule,
    // GoogleMapsModule, // Temporarily removed for Angular 19 compatibility
    ConnectionStatusComponent,
    environment.production ? [] : [],
    environment.production ? [] : ApiFakerModule,
  ],
  providers: [
    {
      provide: EnvConfig,
      useValue: environment,
    },
    {
      provide: DEFAULT_CURRENCY_CODE,
      useFactory: (env: EnvConfig) => env.currencyCode,
      deps: [EnvConfig],
    },
    {
      provide: LOCALE_ID,
      useFactory: (env: EnvConfig) => env.enforcedLocaleId ?? getLocaleKey(navigator.language),
      deps: [EnvConfig],
    },
    {
      provide: MatPaginatorIntl,
      useFactory: (translate: TranslateService) => new WaiMatPaginatorIntl(translate),
      deps: [TranslateService],
    },
    provideHttpClient(withJsonpSupport()),

    providePrimeNG({
      theme: {
        preset: Lara,
        options: {
          darkModeSelector: '.app-dark',
        },
      },
    }),
  ],
})
export class AppModule { }
